import React from 'react';
import dayjs from 'dayjs';
export default function Calhour(date1, date2) {
  const sum = dayjs(date1).diff(dayjs(date2), 'h');
  if (sum <= 8) {
    return sum;
  }
  return 8;
}
